import { SubscriptionPlanName } from '@sparemin/api-sdk';
import { createApiAction } from '../utils';
import * as types from './types';

const DEFAULT_PLAN_NAMES: SubscriptionPlanName[] = [
  SubscriptionPlanName.FREE_FOREVER,
  SubscriptionPlanName.PRO_MONTHLY,
  SubscriptionPlanName.PRO_YEARLY,
  SubscriptionPlanName.ENTERPRISE_FOREVER,
  SubscriptionPlanName.ENTERPRISE_API_INTEGRATOR_FOREVER,
  SubscriptionPlanName.PRO_EDUCATION_CHARITY_FOREVER,
  SubscriptionPlanName.PRO_ADMIN_ASSIGNED_MANUAL,
  SubscriptionPlanName.PRO_TRIAL_MANUAL,
  SubscriptionPlanName.PRO_20250516_MONTHLY,
  SubscriptionPlanName.PRO_20250516_YEARLY,
  SubscriptionPlanName.BASIC_20250516_MONTHLY,
  SubscriptionPlanName.BASIC_20250516_YEARLY,
  SubscriptionPlanName.PRO_20250818_MONTHLY,
  SubscriptionPlanName.PRO_20250818_YEARLY,
  SubscriptionPlanName.PRO_GROW_20251120_MONTHLY,
  SubscriptionPlanName.PRO_GROW_20251120_YEARLY,
  SubscriptionPlanName.BASIC_20250818_MONTHLY,
  SubscriptionPlanName.BASIC_20250818_YEARLY,
  SubscriptionPlanName.EDUCATION_NON_PROFIT_FOREVER,
  SubscriptionPlanName.UNLIMITED_20211112_MONTHLY,
  SubscriptionPlanName.UNLIMITED_20211112_YEARLY,
];

function apiCallAction<M extends types.ServiceMethod, A = undefined>(
  method: M,
  args?: A,
) {
  return createApiAction(types.ACTION_KEY, method, args);
}

export function getPlans(
  planNames?: SubscriptionPlanName[],
): types.GetPlansAction {
  return apiCallAction(types.ServiceMethod.GET_PLANS, {
    plan: planNames ?? DEFAULT_PLAN_NAMES,
  });
}

export function getMySubscription(): types.GetMySubscriptionAction {
  return apiCallAction(types.ServiceMethod.GET_MY_SUBSCRIPTION);
}

export function updateMySubscription(
  args: types.UpdateMySubscriptionArgs,
): types.UpdateMySubscriptionAction {
  return apiCallAction(types.ServiceMethod.UPDATE_MY_SUBSCRIPTION, args);
}

export function createPaymentMethod(
  args: types.CreatePaymentMethodArgs,
): types.CreatePaymentMethodAction {
  return apiCallAction(types.ServiceMethod.CREATE_PAYMENT_METHOD, args);
}

export function getMyCustomerDetails(): types.GetCustomerAction {
  return apiCallAction(types.ServiceMethod.GET_CUSTOMER);
}

export function getMyCoupons(): types.GetMyCouponsAction {
  return apiCallAction(types.ServiceMethod.GET_MY_COUPONS);
}

export function getMyReferral(): types.GetMyReferralAction {
  return apiCallAction(types.ServiceMethod.GET_MY_REFERRAL);
}

export function getMyPodcastPromoCredits(): types.GetMyPodcastPromoCreditsAction {
  return apiCallAction(types.ServiceMethod.GET_MY_PODCAST_PROMO_CREDITS);
}

export function sendReferralInvitations(
  emailAddresses: string[],
): types.SendReferralInvitationsAction {
  return apiCallAction(types.ServiceMethod.SEND_REFERRAL_INVITATIONS, {
    emailAddresses,
  });
}

export function getExternalPortalLink(
  returnUrl?: string,
): types.GetExternalPortalLinkAction {
  return apiCallAction(types.ServiceMethod.GET_EXTERNAL_PORTAL_LINK, {
    returnUrl,
  } as types.GetExternalPortalLinkArgs);
}

export function getPromotion(promotionKey: string): types.GetPromotionAction {
  return apiCallAction(types.ServiceMethod.GET_PROMOTION, { promotionKey });
}

export function acceptPromotion(
  promotionKey: string,
): types.AcceptPromotionAction {
  return apiCallAction(types.ServiceMethod.ACCEPT_PROMOTION, { promotionKey });
}
